import React from 'react';

interface BgisIconProps {
  src?: string;
  iconName?:string;
}

export const BgisIcon: React.FC<BgisIconProps> = ({src, iconName}) => {
  
  if (src) {
    return <img src={src} className="bgis-icon" alt=""></img>;
  } else if (iconName) {
    return <i  className={"bgis-icon "+iconName}></i>;
  } else {
    return <></>;
  }
};

